<template>
  <div class="areaSelect" :style="{ height: `${innerHeight}px` }">
    <div class="areaSelect__ui">
      <transition name="fade">
      <div
        @click="large"
        class="areaSelect__large buttonMini button--dark bold"
        v-show="introEnd"
      >
        全体を見る
      </div>
      </transition>
    </div>

    <transition name="fade2">
    <div class="areaSelect__all" v-show="showModal">
      <div class="areaSelect__allUI">
        <div
          @click="close"
          class="areaSelect__close buttonMini buttonMini--circle38 button--dark"
        >
          <img src="../assets/ui/close.png" width="15" alt="" />
        </div>
      </div>
      <div class="areaSelect__allClip" :style="clipPath"></div>
      <div
        ref="areaSelect__allImage"
        class="areaSelect__allImage"
        :style="{
          height: `${innerHeight}px`,
          backgroundImage: `url('${largeBg}')`
        }"
      ></div>
    </div>
    </transition>

    <div class="areaSelect__inner" :style="{ top: `${offsetY}px` }">
      <transition v-on:enter="enterFx">
        <div v-show="introEnd">
          <div class="areaSelect__text areaSelect__text--1 textShadow">
            <span
              v-for="(t, index) in '描く場所を決めよう！'"
              :key="index"
              v-text="t"
              class="spanLetters"
            />
          </div>
          <div class="areaSelect__text areaSelect__text--2 textShadow">
            赤い斜線部には描けません
          </div>
        </div>
      </transition>
      <div class="areaSelect__button ">
        <div
                v-show="introEnd"
          @click="checkAvailablePos"
          class="buttonPrimary"
        >
          ここに決める
        </div>
      </div>
      <div class="areaSelect__clip">
        <svg :viewBox="viewBox">
          <path :d="svgDraw" fill-rule="evenodd" fill="rgba(0, 0, 0, 0.3)" />
          <rect
            class="svgDashed"
            :d="svgClipRect"
            stroke="white"
            :x="clip.x"
            :y="clip.y"
            :width="clip.w"
            :height="clip.h"
            fill="none"
          />
        </svg>
      </div>
      <div class="otherUsesContainer">
        <OtherUsers :offset="offset" ref="otherUsers"></OtherUsers>
      </div>
      <div class="restrictImgContainer">
        <div
          class="restrictImg"
          :style="{
            maskImage: `url('${restrictImg}')`,
            left: `${this.offset.x}px`,
            top: `${this.offset.y}px`
          }"
        >
          <!--                  maskImage: `url('${restrictImg}')`,
  -->
          <div class="restrictImg__border"></div>
        </div>
      </div>
      <div class="areaSelect__bg" ref="areaSelect__bg">
        <img
          id="bgImg"
          :src="largeBg"
          :style="{
            left: `${this.offset.x}px`,
            top: `${this.offset.y}px`
          }"
          alt=""
        />
      </div>
      <div class="areaSelect__kinsi">
        <img
          id="kinsiImg"
          ref="kinsiImg"
          :src="restrictImg"
          crossorigin="anonymous"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import API from "../api/API";
import * as types from "../store/modules/area/areatype";
import * as StoreUtil from "../util/StoreUtil";
import { TweenMax, Expo, Power2 } from "gsap";
import { DrawEvent } from "../events/DrawEvent";
import * as drawEventType from "../events/DrawEventType";
import { throttle } from "lodash";
import * as flowEvents from "../events/FlowEvents";
import {spanAnim} from "../util/TweenUtil";
import OtherUsers from "../components/area/OtherUsers";
const w = 1920;
const h = 1080;

export default {
  name: "AreaSelect",
  computed: {
    w() {
      return this.$store.state.canvas.stage.width;
    },
    h() {
      return 540;
      // return this.$store.state.canvas.stage.height;
    },
    viewBox() {
      return `0 0 ${this.w} ${this.h}`;
    },
    svgClipRect() {
      return `M ${this.clip.x} ${this.clip.y} v ${this.clip.h} h ${this.clip.w} v -${this.clip.h} Z`;
    },
    svgDraw() {
      return `M 0 0 H ${this.w} V ${this.h} H 0 Z
      ${this.svgClipRect}`;
    },
    info() {
      return this.$store.state.concert.info;
    },
    largeBg() {
      return this.info.last_pseudo_screen_image_url;
    },
    restrictImg() {
      return this.info.restrict_image_url;
    },
    cropRect() {
      return this.$store.state.area.crop;
    },
    clipPath() {
      const ratio = window.innerWidth / w;
      const pos = this.getPos();
      const left = (pos.x / w) * 100;
      const right = ((pos.x + this.clip.w) / w) * 100;

      const fixedH = this.h * ratio;
      const y = (pos.y / this.h) * fixedH;
      const cropH = this.$store.state.area.crop.height;
      const halfH = (window.innerHeight - fixedH) * 0.5;
      const top = ((halfH + y) / window.innerHeight) * 100;
      const bottom =
        top + ((cropH * 0.5 * (fixedH / this.h)) / window.innerHeight) * 100;
      // console.log("fixedH / this.h", fixedH / this.h);
      const clip = `polygon(0% 0%, 0% 100%, ${left}% 100%, ${left}% ${top}%, ${right}% ${top}%, ${right}% ${bottom}%, ${left}% ${bottom}%, ${left}% 100%, 100% 100%, 100% 0%)`;
      return `clip-path: ${clip}; -webkit-clip-path: ${clip};`;
    }
  },
  components: {
    OtherUsers
  },
  data() {
    return {
      clip: { w: 0, h: 0, x: 0, y: 0 },
      pressed: false,
      showModal: false,
      introEnd: false,
      offset: {
        x: 0,
        y: 0
      },
      lastPos: {
        x: 0,
        y: 0
      },
      tweenObj: {
        x: 0,
        y: 0
      },
      offsetY: 0,
      innerHeight: 700
    };
  },
  async mounted() {
    this.innerHeight = window.innerHeight;
    this.reset();
    await this.getConcertInfo();
    this.addEvents();
    this.offsetY = (window.innerHeight - 540) * 0.5;
  },
  methods: {
    enterFx() {
      spanAnim(".areaSelect__text--1 > span");
      TweenMax.fromTo(
              ".areaSelect__text--2",
              0.5,
              { opacity: 0, y: 10 },
              { opacity: 1.0, y: 0, ease: Expo.easeOut, delay: 0.5 },
              0.03
      );
    },
    addEvents() {
      const node = document.querySelectorAll(".areaSelect__clip")[0];
      node.addEventListener("mousedown", this.mousedown);
      node.addEventListener("touchstart", this.mousedown);
      document.addEventListener("mouseup", this.mouseup);
      document.addEventListener("touchend", this.mouseup);
      node.addEventListener("mousemove", this.handleMousemove);
      node.addEventListener("touchmove", this.handleMousemove);
      DrawEvent.on(drawEventType.RESET, this.reset);

      flowEvents.FlowEvents.on(flowEvents.END_AREA, this.decidePos);
    },
    removeEvents() {
      const node = document.querySelectorAll(".areaSelect__clip")[0];
      node.removeEventListener("mousedown", this.mousedown);
      node.removeEventListener("touchdown", this.mousedown);
      document.removeEventListener("mouseup", this.mouseup);
      document.removeEventListener("touchend", this.mouseup);
      node.removeEventListener("mousemove", this.handleMousemove);
      node.removeEventListener("touchmove", this.handleMousemove);
      DrawEvent.off(drawEventType.RESET, this.reset);

      flowEvents.FlowEvents.off(flowEvents.END_AREA, this.decidePos);
    },
    async getConcertInfo() {
      const concertId = this.$store.state.concert.concertId;
      return await API.getConcertInfo(concertId);
    },
    large() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
    reset() {
      this.clip.w = this.$store.state.area.crop.width * 0.5;
      this.clip.h = this.$store.state.area.crop.height * 0.5;
      this.introEnd = false;
      this.clip.x = (this.w - this.clip.w) * 0.5;
      this.clip.y = (this.h - this.clip.h) * 0.5;
      this.offset.x = this.getCenterOffsetX();
      this.tweenObj.x = this.tweenObj.y = 0;
    },
    mousedown(e) {
      if (!this.introEnd) {
        e.preventDefault();
        return;
      }
      this.pressed = true;
      this.updateLastPos(e);
      e.preventDefault();
    },
    mouseup(e) {
      this.pressed = false;
      this.checkPos();
    },
    handleMousemove: throttle(function(e) {
      this.move(e);
      e.preventDefault();
    }, 16),
    move(e) {
      if (!this.pressed) return;

      const pos = this.getTouch(e);
      const diff = {
        x: this.lastPos.x - pos.clientX,
        y: this.lastPos.y - pos.clientY
      };

      this.offset.x -= diff.x;
      this.offset.y -= diff.y;

      this.updateLastPos(e);
      e.preventDefault();
    },
    getTouch(e) {
      const result = { clientX: e.clientX, clientY: e.clientY };
      if (e.touches && e.touches[0]) {
        result.clientX = e.touches[0].clientX;
        result.clientY = e.touches[0].clientY;
      }
      return result;
    },
    updateLastPos(e) {
      const pos = this.getTouch(e);
      this.lastPos.x = pos.clientX;
      this.lastPos.y = pos.clientY;
    },
    checkPos() {
      const pos = this.getPos();
      const btmY = this.h - this.clip.h;
      const rightX = w - this.clip.w;
      let flag = false;
      let x = this.offset.x;
      let y = this.offset.y;

      if (pos.x < 0) {
        flag = true;
        x = -this.clip.w * 0.5 + this.w * 0.5;
      } else if (pos.x > rightX) {
        flag = true;
        x = -w + this.clip.w + this.clip.x;
      }

      if (pos.y < 0) {
        flag = true;
        y = -this.clip.h * 0.5 + this.h * 0.5;
      } else if (pos.y > btmY) {
        flag = true;
        y = -this.clip.y;
      }
      if (flag) this.tween(x, y);
    },
    tween(x, y) {
      this.tweenObj.x = this.offset.x;
      this.tweenObj.y = this.offset.y;
      TweenMax.to(this.tweenObj, 0.5, {
        x: x,
        y: y,
        ease: Expo.easeInOut,
        onUpdate: () => {
          this.updateTween();
        }
      });
    },
    updateTween() {
      this.offset.x = this.tweenObj.x;
      this.offset.y = this.tweenObj.y;
    },
    getPos() {
      const pos = {
        x: -this.clip.w * 0.5 - (this.offset.x - this.w * 0.5),
        y: -this.clip.h * 0.5 - (this.offset.y - this.h * 0.5)
      };
      return pos;
    },
    dispatchPos(x, y) {
      StoreUtil.setAreaPos(x, y);
    },
    setThisPos() {
      const pos = this.getPos();
      this.dispatchPos(pos.x * 2, pos.y * 2);
    },
    checkAvailablePos() {
      this.setThisPos();
      flowEvents.FlowEvents.emit(flowEvents.DETERMINE_AREA);
    },
    decidePos() {
      this.setThisPos();
      StoreUtil.gotoTutorial();
    },
    getCenterOffsetX() {
      return (this.w - w) * 0.5;
    },
    checkAreaImg() {
      console.log("this.restrictImg", this.restrictImg, this.$refs.kinsiImg.width);
      if (!this.restrictImg || this.$refs.kinsiImg.width < 1) {
        alert("データが破損しています。再読み込みします");
        location.reload();
        return;
      }
    },
    show() {
      this.checkAreaImg();
      this.$refs.otherUsers.start();
      this.introEnd = false;
      const el = this.$refs.areaSelect__bg;
      TweenMax.fromTo(
        el,
        1.4,
        { scale: 0.6 },
        { scale: 1, ease: Expo.easeOut }
      );

      let duration = 1.3;
      let duration2 = 3.3;
      let delay = 1.5;
      let delayInterval = 0.3;
      const ease = Power2.easeInOut;
      //左
      TweenMax.to(this.offset, duration, {
        x: 135,
        ease: ease,
        delay: delay
      });

      //右
      delay += duration + delayInterval;
      TweenMax.to(this.offset, 3, {
        x: -1680,
        ease: ease,
        delay: delay
      });
      //中央
      delay += duration2 + delayInterval;
      TweenMax.to(this.offset, duration + 0.2, {
        x: this.getCenterOffsetX(),
        ease: ease,
        delay: delay,
        onComplete: () => {
          this.introEnd = true;
        }
      });
    },
    hide() {
      const el = this.$refs.areaSelect__bg;

      el.style.transformOrigin = `${this.left}px ${this.top}px`;
      TweenMax.fromTo(el, 1.3, { scale: 1 }, { scale: 1.4, ease: Expo.easeIn, onComplete: ()=> {
        this.$refs.otherUsers.hide();
        }});


    }
  }
};
</script>

<style scoped lang="sass">
@import "../sass/common"
.areaSelect
    position: relative
    //overflow: hidden
.areaSelect__ui
    position: absolute
    z-index: 100
    right: 15px
    top: 15px
.areaSelect__all
    position: absolute
    z-index: 150
    @include fit()
.areaSelect__allUI
    position: absolute
    z-index: 2
    right: 15px
    top: 15px
.areaSelect__allClip
  background-color: rgba(0, 0, 0, 0.5)
  //background-color: rgba(255, 255, 255, 0.5)
  position: absolute
  z-index: 1
  @include fit
.areaSelect__allImage
    @include fitWH()
    background-position: center center
    background-repeat: no-repeat
    background-size: contain
    background-color: #000
.areaSelect__clip
    position: absolute
    z-index: 20
    @include fit()
    svg
        width: 100%
.areaSelect__text
  @include vw(20)
  @include bold
  position: absolute
  z-index: 100
  top: 172px
  width: 100%
  pointer-events: none
  text-align: center
  &.areaSelect__text--2
    @include vw(15)
    font-weight: normal
    top: 340px

.areaSelect__button
  position: absolute
  z-index: 100
  bottom: 40px
  width: 100%
  .buttonPrimary
    margin: auto
.areaSelect__inner
  position: relative
  //top: 40px
  min-height: 540px
  overflow: hidden


.areaSelect__bg
    transform-origin: center center
    height: 540px
    img#bgImg
      position: absolute
      width: 1920px
      height: 540px
    //background-position: center top
    //background-repeat: no-repeat
.otherUsesContainer
  pointer-events: none
  position: absolute
  @include fit()
  overflow: hidden
  z-index: 11
.restrictImgContainer
  pointer-events: none
  position: absolute
  @include fit()
  overflow: hidden
  z-index: 10
.areaSelect__kinsi
  display: none
.restrictImg
  position: absolute
  width: 1920px
  height: 540px
  //background: url("../assets/ui/alpha-mask2.png") no-repeat center center
  //background-size: 100%
  mask-mode: alpha
  mask-size: 100%
  //mask-image: url("../assets/ui/alpha-mask.png")
  //mask-image: url("../assets/ui/mask.png")
  mask-position: center center
  .restrictImg__border
    //display: none
    background: url("../assets/ui/kinsi.png") repeat
    width: 1920px
    height: 540px
    animation: kinsiBgAnim 5s infinite linear, kinsiBgAnimAlpha 2s infinite ease-in-out,
.svgDashed
    stroke-dasharray: 5
    animation: dash 1s linear infinite
    pointer-events: none
.fade-enter-active, .fade-leave-active
  transition: all .5s
.fade-enter, .fade-leave-to
  opacity: 0
.fade2-enter-active, .fade2-leave-active
  transition: all .2s ease-out
.fade2-enter, .fade2-leave-to
  opacity: 0
  transform: translateY(10px)
@keyframes dash
    0%
        stroke-dashoffset: 100
    100%
        stroke-dashoffset: 110
@keyframes kinsiBgAnim
    0%
        background-position: 0 0
    100%
        background-position: 81px 0
@keyframes kinsiBgAnimAlpha
    0%
        opacity: 1
    50%
        opacity: 0.35
    100%
        opacity: 1
</style>
